/**
 * @desc getCustomsDeclarationQuantitiesByPoList
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.CustomDeclarationResponseRpcDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/getCustomsDeclarationQuantitiesByPoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
